"use client";
const e = Object.freeze({
  toast: 1040,
  popover: 1030,
  select: 1020,
  combobox: 1020,
  datePicker: 1020,
  dialog: 1010,
  drawer: 1e3
});
export {
  e as LAYERS
};
